import Accordion from '@/components/accordion';
import Club from '@/components/club-item';
import ClubSearchBar from '@/components/club-search-bar';
import Icon from '@/components/icon';
import MapStoreFinder from '@/components/map-store-finder';
import UiModal from '@/components/modal';
import SimpleMap from '@/components/simple-map';

export default {
    Accordion,
    Club,
    ClubSearchBar,
    Icon,
    MapStoreFinder,
    UiModal,
    SimpleMap,
};
